(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reels"] && !Shopify.designMode) return;
  try {
    
class SeaShoppableVideos extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    this.slider = null

    setTimeout(() => {
      if (!window.Swiper) return

      this.slider = new window.Swiper(this.querySelector('.swiper'), this.sliderOptions())

      this.slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.pauseAllVideos()
      })

      this.slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
        this.playFocusedVideo()
      })

      this.playFocusedVideo()
    }, 700)

    this.querySelectorAll('video').forEach(video => {
      video.muted = true
      video.controls = false
      video.playsInline = true
      video.setAttribute('muted', '')
      video.setAttribute('playsinline', '')
      video.setAttribute('webkit-playsinline', '')
      video.removeAttribute('controls')

      video.addEventListener('click', event => {
        event.preventDefault()
      })

      video.addEventListener('ended', () => {
        this.onVideoEnded(video)
      })
    })

    this.querySelectorAll('.sea-shoppable-videos-btn-sound').forEach(btn => {
      btn.addEventListener('click', event => {
        event.preventDefault()
        event.stopPropagation()

        const card = btn.closest('.sea-shoppable-videos-card')
        const video = card?.querySelector('video')
        if (!video) return

        this.pauseAllVideos(card)

        if (video.muted) {
          video.muted = false
          video.removeAttribute('muted')
          card.setAttribute('data-is-muted', 'false')
        } else {
          video.muted = true
          video.setAttribute('muted', '')
          card.setAttribute('data-is-muted', 'true')
        }

        card.setAttribute('data-is-playing', 'true')
        video.play().catch(() => {})
      })
    })
  }

  sliderOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    return {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: true,
        dynamicMainBullets: 2
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },
      autoplay: false,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      }
    }
  }

  getFocusedCard () {
    return this.querySelector('.swiper-slide-active .sea-shoppable-videos-card')
      || this.querySelector('.swiper-slide-visible .sea-shoppable-videos-card')
      || this.querySelector('.sea-shoppable-videos-card')
  }

  pauseAllVideos (exceptCard = null) {
    this.querySelectorAll('.sea-shoppable-videos-card').forEach(card => {
      if (exceptCard && card === exceptCard) return

      const video = card.querySelector('video')
      if (!video) return

      video.pause()
      video.muted = true
      video.setAttribute('muted', '')
      video.currentTime = 0
      video.controls = false
      video.removeAttribute('controls')

      card.setAttribute('data-is-playing', 'false')
      card.setAttribute('data-is-muted', 'true')
    })
  }

  playFocusedVideo () {
    const focusedCard = this.getFocusedCard()
    if (!focusedCard) return

    this.pauseAllVideos(focusedCard)

    const focusedVideo = focusedCard.querySelector('video')
    if (!focusedVideo) return

    focusedVideo.muted = true
    focusedVideo.setAttribute('muted', '')
    focusedVideo.controls = false
    focusedVideo.removeAttribute('controls')
    focusedVideo.currentTime = 0

    focusedCard.setAttribute('data-is-playing', 'true')
    focusedCard.setAttribute('data-is-muted', 'true')

    focusedVideo.play().catch(() => {})
  }

  onVideoEnded (video) {
    video.muted = true
    video.setAttribute('muted', '')

    const card = video.closest('.sea-shoppable-videos-card')
    if (card) {
      card.setAttribute('data-is-muted', 'true')
      card.setAttribute('data-is-playing', 'false')
    }

    if (this.slider) {
      this.slider.slideNext()
    }
  }
}

customElements.define('sea-shoppable-videos', SeaShoppableVideos)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
